import useIsMobile from '@/helpers/commonHooks/useIsMobile'
import InfoBindPagePc from './components/InfoBindPagePc/InfoBindPagePc'
import InfoBindPageMobile from './components/InfoBindPageMobile/InfoBindPageMobile'
import { observer } from 'mobx-react'

function InfoBindPage() {
  const isMobile = useIsMobile()
  return isMobile ? <InfoBindPageMobile /> : <InfoBindPagePc />
}

export default observer(InfoBindPage)
